/**
 * 缅甸语
 */
export default {
  name: 'my',
  el: {
    colorpicker: { confirm: 'အတည်ပြုပါ', clear: 'ရှင်းလင်း' },
    datepicker: {
      now: 'ယခုအချိန်',
      today: 'ယနေ့',
      cancel: 'ပယ်ဖျက်ပါ',
      clear: 'ရှင်းလင်း',
      confirm: 'အတည်ပြုပါ',
      selectDate: 'ရွေးချယ်ရက်',
      selectTime: 'ရွေးချယ်ရက်ချိန်',
      startDate: 'စတင်ကုန်ခြားရက်',
      startTime: 'စတင်ကုန်ခြားအချိန်',
      endDate: 'အဆုံးခြားရက်',
      endTime: 'အဆုံးခြားအချိန်',
      prevYear: 'ယခုအခြားနှစ်',
      nextYear: 'နောက်အခြားနှစ်',
      prevMonth: 'ယခုအခြားလ',
      nextMonth: 'နောက်အခြားလ',
      year: 'နှစ်',
      month1: 'ဇန်နဝါရီ',
      month2: 'ဖေဖော်ဝါရီ',
      month3: 'မတ်',
      month4: 'ဧပြီ',
      month5: 'မေ',
      month6: 'ဇွန်',
      month7: 'ဇူလိုင်',
      month8: 'သြဂုတ်',
      month9: 'စက်တင်ဘာ',
      month10: 'အောက်တိုဘာ',
      month11: 'နိုဝင်ဘာ',
      month12: 'ဒီဇင်ဘာ',
      weeks: {
        sun: 'နွေ',
        mon: 'တနင်္လာ',
        tue: 'အင်္ဂါ',
        wed: 'ဗုဒ္ဓဟူး',
        thu: 'ကြာသပတေး',
        fri: 'သောကြာ',
        sat: 'စနေ'
      },
      months: {
        jan: 'ဇန်နဝါရီ',
        feb: 'ဖေဖော်ဝါရီ',
        mar: 'မတ်',
        apr: 'ဧပြီ',
        may: 'မေ',
        jun: 'ဇွန်',
        jul: 'ဇူလိုင်',
        aug: 'သြဂုတ်',
        sep: 'စက်တင်ဘာ',
        oct: 'အောက်တိုဘာ',
        nov: 'နိုဝင်ဘာ',
        dec: 'ဒီဇင်ဘာ'
      }
    },
    select: {
      loading: 'တင်နေသည်',
      noMatch: 'မတူကြောင်းသောအချက်များ',
      noData: 'အချက်အလက်မရှိပါ',
      placeholder: 'ရွေးချယ်ပါ'
    },
    cascader: {
      noMatch: 'မတူကြောင်းသောအချက်များ',
      loading: 'တင်နေသည်',
      placeholder: 'ရွေးချယ်ပါ',
      noData: 'အချက်အလက်မရှိပါ'
    },
    pagination: {
      goto: 'သွားရန်',
      pagesize: 'စာမျက်နှာ / စာအုပ်',
      total: 'စုစုပေါင်း {total} ခုရာများ',
      pageClassifier: 'စာမျက်နှာ',
      page: 'စာမျက်နှာ',
      prev: 'နောက်သို့',
      next: 'နောက်ပိုင်း',
      currentPage: 'စာမျက်နှာ {pager}',
      prevPages: 'နောက်ခံ {pager} စာမျက်နှာများ',
      nextPages: 'နောက်ပိုင်း {pager} စာမျက်နှာများ',
      deprecationWarning:
        'သင့်အသုံးပြုသူများသည်အသုံးပြုပုံကိုပြောင်းလဲထားသည်။ el-pagination ရဲ့အစီအစဉ်ကိုကြည့်ရှုနိုင်ပါသည်'
    },
    messagebox: {
      title: 'သတိပေးချက်',
      confirm: 'သေချာပါ',
      cancel: 'ပယ်ဖျက်ပါ',
      error: 'ထည့်သွင်းထားသောဒေတာသည် မမှန်ကန်ပါ။!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: 'ဖျက်ရန် delete ကိုနှိပ်ပါ။',
      preview: 'ပုံကိုကြည့်ပါ။',
      continue: 'ဆက်လက်တင်ခြင်း။'
    },
    table: {
      emptyText: 'ဒေတာမရှိပါ။',
      confirmFilter: 'ဇကာ',
      resetFilter: 'ပြန်လည်သတ်မှတ်ပါ။',
      clearFilter: 'အားလုံး',
      sumText: 'စုစုပေါင်း'
    },
    tree: {
      emptyText: 'ဒေတာမရှိပါ။'
    },
    transfer: {
      noMatch: 'တောင်းပန်းမတွေ့ရှိပါ',
      noData: 'အချက်အလက်မရှိပါ',
      titles: ['စာရင်း ၁', 'စာရင်း ၂'],
      filterPlaceholder: 'ရှာဖွေရန်နောက်ထပ်ထည့်ပါ',
      noCheckedFormat: 'စုစုပေါင်း {total} စာရင်း',
      hasCheckedFormat: 'ရွေးချယ်ထားသော {checked}/{total} စာရင်း'
    },
    image: { error: 'တင်သွင်းနေပြီ' },
    pageHeader: { title: 'ပြန်စစ်မှု' },
    popconfirm: { confirmButtonText: 'သေချာပါ', cancelButtonText: 'ပယ်ဖျက်ပါ' }
  }
}
